import React from 'react'
import globalStyles from "../../../../Styles/global.module.scss"
import styles from "../../../../Styles/ComponentStyles/GlobalComponentStyles/AppNavbarChildren.module.scss"

// MUI 
import Grid from '@mui/material/Grid2';

// GLOBAL
import GlobalButton from '../../../../Utils/Layout/GlobalButton/GlobalButton';

// ICONS
import Icons from '../../../../Utils/Layout/Icons/Icons';
import { IconButton } from '@mui/material';
import { useIsBelow600 } from '../../../../Utils/Constant/Constant';
import CalculateIcon from '@mui/icons-material/Calculate';

const Plan401kChildren = (props: any) => {

    const { handleCalculateFeesImpact, handleFeeComparisonPdf, plan401kDetails, resultRef, displayedYearData } = props

    const isBelow600 = useIsBelow600();

    const isValidValue = (value: any): boolean => {
        if (value === undefined || value === null || value === '') return false;

        // Convert to string and remove common formatting
        const stringValue = String(value).replace(/[$,\s%]/g, '').trim();

        // Check if it's effectively zero or empty
        if (stringValue === '' || stringValue === '0' || stringValue === '0.00' || stringValue === '0%') {
            return false;
        }

        // For percentage values, check if the numeric part is 0
        if (stringValue.includes('%')) {
            const numericPart = parseFloat(stringValue.replace('%', ''));
            return !isNaN(numericPart) && numericPart > 0;
        }

        // For monetary values, check if the numeric part is greater than 0
        const numericValue = parseFloat(stringValue);
        return !isNaN(numericValue) && numericValue > 0;
    };

    // Validation function to check if required fields are not empty
    const validateRequiredFields = (): boolean => {
        if (!plan401kDetails) return false;

        const { planAssumptions, fees } = plan401kDetails;

        // Check plan assumptions - all must be valid
        const isPlanAssumptionsValid =
            isValidValue(planAssumptions?.rollover) &&
            isValidValue(planAssumptions?.annualContribution) &&
            isValidValue(planAssumptions?.annualPlanGrowth);

        // Check fees - both acrylic and otherCompany totals must be valid
        const isAcrylicFeesValid =
            isValidValue(fees?.acrylic?.annualFeesPaidByBusiness?.totalAnnualFeesPaidByBusiness) &&
            isValidValue(fees?.acrylic?.annualFeesPaidByPlanAssets?.totalAannualFeesPaidByPlanAssets);

        const isOtherCompanyFeesValid =
            isValidValue(fees?.otherCompany?.annualFeesPaidByBusiness?.totalAnnualFeesPaidByBusiness) &&
            isValidValue(fees?.otherCompany?.annualFeesPaidByPlanAssets?.totalAannualFeesPaidByPlanAssets);

        return isPlanAssumptionsValid && isAcrylicFeesValid && isOtherCompanyFeesValid;
    };

    const isButtonsEnabled = validateRequiredFields();

    return (
        <>
            <Grid size={{ xs: 12 }}>
                <Grid container className={`${styles.plan401kContainer}`}>
                    {isBelow600 ? (
                        <>
                            <IconButton
                                sx={{ padding: "2px" }}
                                disabled={!isButtonsEnabled}
                                onClick={() => {
                                    if (isButtonsEnabled) {
                                        handleFeeComparisonPdf(displayedYearData);
                                    }
                                }}
                            >
                                <Icons
                                    iconName="downloadIcon"
                                    iconWidth="14px"
                                    iconHeight="14px"
                                />
                            </IconButton>
                            <IconButton
                                sx={{ padding: "2px" }}
                                disabled={!isButtonsEnabled}
                                onClick={() => {
                                    if (isButtonsEnabled) {
                                        handleCalculateFeesImpact();

                                        setTimeout(() => {
                                            if (resultRef?.current) {
                                                resultRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                                            }
                                        }, 400);
                                    }
                                }}
                            >
                                <CalculateIcon sx={{ color: "white" }} />
                            </IconButton>
                        </>
                    ) : (
                        <>
                            <Grid className={`${styles.plan401kBtnItem}`}>
                                <GlobalButton
                                    fullWidth={true}
                                    value='Download'
                                    variant='outlined'
                                    className={styles.downloadBtnStyles}
                                    size='medium'
                                    startIcon={<Icons iconName="downloadIcon" iconColor="white" iconWidth="14px" iconHeight="14px" />}
                                    onClick={() => {
                                        if (isButtonsEnabled) {
                                            handleFeeComparisonPdf(displayedYearData);
                                        }
                                    }}
                                    disabled={!isButtonsEnabled}
                                />
                            </Grid>
                            <Grid className={`${styles.plan401kBtnItem}`}>
                                <GlobalButton
                                    fullWidth={true}
                                    value='Calculate'
                                    variant='contained'
                                    className={styles.calculateBtnStyles}
                                    size='medium'
                                    onClick={() => {
                                        if (isButtonsEnabled) {
                                            handleCalculateFeesImpact();

                                            setTimeout(() => {
                                                if (resultRef?.current) {
                                                    resultRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                                                }
                                            }, 400);
                                        }
                                    }}
                                    disabled={!isButtonsEnabled}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>
        </>
    )
}


export default Plan401kChildren